/* eslint-disable jsx-a11y/accessible-emoji */
import * as React from 'react';
import dotenv from 'dotenv';

// React Routing
import { NativeBaseProvider } from 'native-base';
import { BrowserRouter } from 'react-router-dom';

// Fonts
import { useFonts } from 'expo-font';
import { StatusBar } from 'expo-status-bar';
import { loadFonts, theme } from '@breakroom-nx/assets';

// Components
import { AuthNavigator } from '../components/auth-navigator/auth-navigator';
import { ModalManager } from '@breakroom-nx/ui';
import { SafeAreaProvider } from 'react-native-safe-area-context';

// Redux
import { store } from '@breakroom-nx/redux';
import { Provider } from 'react-redux';

// Action Sheet
import { ActionSheetProvider } from '@expo/react-native-action-sheet';

// CSS
import './App.css';

dotenv.config();

export default function App() {
  const [fontsLoaded] = useFonts(loadFonts);

  if (!fontsLoaded) {
    return null;
  } else {
    return (
      <Provider store={store}>
        <SafeAreaProvider>
          <ActionSheetProvider>
            <NativeBaseProvider theme={theme}>
              <StatusBar />
              <ModalManager />
              <BrowserRouter>
                <AuthNavigator />
              </BrowserRouter>
            </NativeBaseProvider>
          </ActionSheetProvider>
        </SafeAreaProvider>
      </Provider>
    );
  }
}
